import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      background: '#050508',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
    }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        style={{
          background: '#0d1117',
          border: '1px solid rgba(0,217,255,0.15)',
          borderRadius: '16px',
          padding: '3rem',
          maxWidth: '480px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: '1.5rem',
        }}
      >
        <p style={{
          fontFamily: 'monospace',
          fontSize: '0.65rem',
          color: 'rgba(255,255,255,0.3)',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          margin: 0,
        }}>
          ERROR // PAGE NOT FOUND
        </p>

        <h1 style={{
          fontSize: 'clamp(5rem, 16vw, 10rem)',
          fontWeight: 900,
          lineHeight: 1,
          margin: 0,
          background: 'linear-gradient(180deg, #ffffff 0%, rgba(255,255,255,0.6) 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          404
        </h1>

        <p style={{
          color: 'rgba(255,255,255,0.4)',
          fontSize: '0.85rem',
          fontFamily: 'monospace',
          lineHeight: 1.6,
          margin: 0,
          maxWidth: '320px',
        }}>
          The page you're looking for doesn't exist or was moved.
        </p>

        <div style={{
          display: 'flex',
          gap: '0.75rem',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginTop: '0.5rem',
        }}>
          <motion.button
            onClick={() => navigate('/')}
            whileHover={{ scale: 1.04, boxShadow: '0 0 20px rgba(0,217,255,0.3)' }}
            whileTap={{ scale: 0.97 }}
            transition={{ duration: 0.15 }}
            style={{
              padding: '0.75rem 2rem',
              borderRadius: '6px',
              border: '1px solid #00d9ff',
              background: 'rgba(0,217,255,0.1)',
              color: '#00d9ff',
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Return Home
          </motion.button>

          <motion.button
            onClick={() => navigate(-1)}
            whileHover={{ scale: 1.04, borderColor: 'rgba(255,255,255,0.3)' }}
            whileTap={{ scale: 0.97 }}
            transition={{ duration: 0.15 }}
            style={{
              padding: '0.75rem 2rem',
              borderRadius: '6px',
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'transparent',
              color: 'rgba(255,255,255,0.5)',
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              fontWeight: 700,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            Go Back
          </motion.button>
        </div>
      </motion.div>
    </div>
  )
}
